<template>
  <div class="sky-server-config">
    <div>
      <span><label style="color: red;">* </label>项目模版名称：</span
      ><el-input style="width: 300px;" v-model="templateName"></el-input>
    </div>
    <div style="text-align: center; margin-top: 10px;">
      <el-button type="primary" class="sky-branch-pattern__add" style="margin-top:5px" @click="onConfirm">
        确定
      </el-button>
      <el-button class="sky-branch-pattern__add" style="margin-top:5px" @click="onCancel">
        取消
      </el-button>
    </div>
  </div>
</template>
<script type="text/babel">
import { Input, Button } from 'element-ui'

import { setDdProjectTemplate } from '@/api/deliveryProject'

export default {
  name: 'SkyCreateTemplateDdProject',
  inject: ['rootView', 'elForm'],
  components: {
    [Input.name]: Input,
    [Button.name]: Button
  },
  props: {
    row: {}
  },
  data() {
    return {
      id: null,
      templateName: null
    }
  },
  mounted() {
    this.id = this.row.id
  },
  watch: {},
  methods: {
    onConfirm() {
      if (!this.templateName) {
        this.$store.dispatch('OpenNotification', { message: '请输入支付部署项目模版名称', type: 'error' })
        return
      }
      setDdProjectTemplate({
        id: this.id,
        templateName: this.templateName
      })
        .then(res => {
          this.$store.dispatch('OpenNotification', { message: '设置支付部署项目模版成功', type: 'success' })
          this.$emit('cb')
        })
        .catch(e => {
          this.$emit('cb')
          throw e
        })
    },
    onCancel() {
      this.$emit('cb')
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';

@include b(version-variable) {
  @include e(more-btn) {
    & .el-button {
      background-color: $--fill-base !important;
      color: $--color-primary !important;
      border: 0 !important;
      line-height: $--font-line-height-base - 0.2em;
      &:hover {
        color: $--color-primary-5 !important;
      }
    }
  }
}
@include b(server-config) {
  margin-bottom: 0px !important;
  @include e(autocomplete) {
    width: auto !important;
    min-width: 180px;
  }
  @include e(select) {
    width: 180px !important;
  }
  @include e(mutiple-select) {
    width: 300px !important;
  }
  @include e(item) {
    line-height: 30px;
    word-break: break-all;
    width: 1400px !important;
    color: $--disabled-color-base;
    &.active {
      color: $--color-primary;
    }
  }
  & i {
    margin-right: 5px;
  }
  & .el-input__inner {
    border-top: 0;
    border-left: 0;
    border-right: 0;
    padding: 0;
  }
  & .el-form-item__error {
    width: 500px !important;
  }
}
</style>
